export enum TabsName {
  MyInsight = 'myInsight',
  Supervisor = 'supervisor'
}
